let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dUr0C")).then(() => parcelRequire('3ZEEP'));